import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/pro-light-svg-icons';
import { Box } from '@mui/material';
import { useNotifier } from '../notifier';

export function CopyToClipboard(props: { toCopy: string; title: string; toastText?: string; onCopy?: () => void }) {
  const { toCopy, title, toastText, onCopy } = props;

  const { dispatch } = useNotifier();

  function handleCopy() {
    navigator.clipboard.writeText(toCopy);
    if (toastText) {
      dispatch({ type: 'notify', payload: { message: toastText } });
    }
    onCopy?.();
  }

  return (
    <Box sx={{ padding: '5px', cursor: 'pointer' }} onClick={handleCopy}>
      <FontAwesomeIcon icon={faCopy} /> {title}
    </Box>
  );
}
